module.exports = __webpack_public_path__ + "media/images/sp/calendar/on-a763e3f02550247d5a689c0496a5cdc2.svg";